import {
	AfterViewInit,
	Component,
	ElementRef,
	HostListener,
	Input,
	OnChanges, OnInit,
	SimpleChanges,
	ViewChild
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {LightGallery} from "lightgallery/lightgallery";
import {LightgalleryModule} from "lightgallery/angular";
import lgZoom from 'lightgallery/plugins/zoom';
import lgVideo from 'lightgallery/plugins/video';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import {LightGalleryItem} from "../interface/light-gallery-item";
import {ObserveBreakpointService} from "../../observe-breakpoint.service";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {DirectiveModule} from "../../directive/directive.module";
import {FabricProfileItemList} from "../../product-details/interface/fabric-profile-item-list";

@UntilDestroy()
@Component({
	selector: 'fb-product-light-gallery',
	standalone: true,
	imports: [CommonModule, LightgalleryModule, DirectiveModule],
	templateUrl: './product-light-gallery.component.html',
	styleUrls: ['./product-light-gallery.component.scss']
})
export class ProductLightGalleryComponent implements AfterViewInit, OnInit, OnChanges {

	public lightGallery!: LightGallery;
	public showArrows: boolean = false;
	public isSizeMd: boolean = true;
	@Input()
	public galleryItems: LightGalleryItem[] = [];
	@Input()
	public hasVideo: boolean = false;

	@Input()
	public selectedFabric: FabricProfileItemList | undefined;

	@Input()
	public productFinish: boolean = false;

	public selectedImageIndex = 0;
	@ViewChild('thumbnailContainer', {static: false})
	thumbnailContainer!: ElementRef<HTMLDivElement>;

	constructor(
		private _breakpointService: ObserveBreakpointService
	) {
	}

	private _checkScrollability() {
		const container = this.thumbnailContainer?.nativeElement;
		if (container) {
			this.showArrows = container.scrollWidth > container.clientWidth;
		}
	}

	ngOnInit() {
		this._breakpointService.observe('md')
			.pipe(untilDestroyed(this))
			.subscribe((isMd) => {
				this.isSizeMd = isMd;
			});
	}

	ngOnChanges(changes: SimpleChanges): void {
		if(changes['selectedFabric']) {
			if(changes['selectedFabric'].previousValue === undefined && this.selectedFabric) {
				this.galleryItems.unshift({
					src: this.selectedFabric.mockupImage ? this.selectedFabric.mockupImage : this.selectedFabric.fabricPreview.heroImage,
					thumb: this.selectedFabric.mockupImage ? this.selectedFabric.mockupImage : this.selectedFabric.fabricPreview.heroImage,
					subHtml: `<h4>Selected Fabric: ${this.selectedFabric.fabricPreview.name}</h4>`,
					type: 'image',
					alt: this.selectedFabric.mockupText ? this.selectedFabric.mockupText : this.selectedFabric.fabricPreview.name
				});
				this.selectedImageIndex = 0;
			}
			else if(changes['selectedFabric'].currentValue !== changes['selectedFabric'].previousValue) {
				if(this.selectedFabric) {
					this.galleryItems[0] = {
						src: this.selectedFabric.mockupImage ? this.selectedFabric.mockupImage : this.selectedFabric.fabricPreview.heroImage,
						thumb: this.selectedFabric.mockupImage ? this.selectedFabric.mockupImage : this.selectedFabric.fabricPreview.heroImage,
						subHtml: `<h4>Selected Fabric: ${this.selectedFabric.fabricPreview.name}</h4>`,
						type: 'image',
						alt: this.selectedFabric.mockupText ? this.selectedFabric.mockupText : this.selectedFabric.fabricPreview.name
					}
				}
				else {
					this.galleryItems.splice(0 , 1);
				}
			}
			this.lightGallery?.refresh(this.galleryItems);
			this._checkScrollability();
		}
	}

	ngAfterViewInit(): void {
		this._checkScrollability();
		this.lightGallery?.refresh(this.galleryItems);

	}

	@HostListener('window:resize')
	public onResize(): void {
		this._checkScrollability();
	}

	public selectImage(index: number): void {
		if (this.galleryItems[index].type !== 'image') {
			this.openGallery(index);
		} else {
			this.selectedImageIndex = index;
		}
	}

	public nextImage(index: number): void {
		if (index < this.galleryItems.length - 1) {
			this.selectedImageIndex++;
		}

	}

	public prevImage(index: number): void {
		if (index > 0) {
			this.selectedImageIndex--;
		}

	}

	public scrollThumbnails(direction: 'left' | 'right'): void {
		const container = this.thumbnailContainer.nativeElement;
		const scrollAmount = 100;

		if (direction === 'left') {
			container.scrollBy({left: -scrollAmount, behavior: 'smooth'});
		} else {
			container.scrollBy({left: scrollAmount, behavior: 'smooth'});
		}
	}


	public settings = {
		dynamic: true,
		dynamicEl: this.galleryItems,
		download: false,
		counter: true,
		enableSwipe: true,
		height: '100%',
		plugins: [lgVideo, lgThumbnail, lgZoom],
		videojs: true,
		autoplayVideoOnSlide: true,
		loadYouTubeThumbnail: true,
	};

	public openGallery(index: number): void {
		this.lightGallery?.openGallery(index);
	}

	public onInit = (detail: any): void => {
		this.lightGallery = detail.instance;
	};

}
